import {
    UPDATE_TABLE_PROPS
} from '../actions/actionTypes';

const initialState = {};

export default (state = initialState, action) => {
    switch (action.type) {
        case UPDATE_TABLE_PROPS:
            return {
                ...state,
                tableProps: { ...action.payload }
            };
        default:
            return state;
    }
};
